import React, {Component} from 'react';
import NavBarKS from "../../components/NavBarKS";
import YearPicker from "../einvoice/YearPicker";
import {deepCopyObject, getYearsList, getYearsListWithMinYear, showAxiosError} from "../../helper/helper";
import VatCard from "./VatCard";
import {request} from "../../helper/APIUtils";
import ReactLoadingTop from "../../components/ReactLoadingTop";
import MediaViewer from "../einvoice/MediaViewer";
import StickButton from "../../components/StickButton";

class VatStateReport extends Component {

    constructor(props) {
        super(props);
        let yearsList = getYearsList();

        this.state = {
            loading:false,
            years:yearsList,
            year:yearsList[0],
            showModal: false,
            vatAmount: {
                depoInAmount: 0,
                depoInKdv: 0,
                estimatedOutAmount: 0,
                estimatedOutKdv: 0,
                genelInAmount: 0,
                genelInKdv: 0,
                sgkAmount: 0,
                sgkOutKdv: 0,
                publicAmount: 0,
                publicKdv: 0,
                eczaciposAmount: 0,
                eczaciposOutKdv: 0,
                otherInAmount: 0,
                otherInKdv: 0,
                outAmount: 0,
                outKdv: 0,
                inAmount: 0,
                inKdv: 0,
                minYear: null,
            },
            month: new Date().getMonth()
        };
        this.fetchData = this.fetchData.bind(this);
        this.setYear = this.setYear.bind(this);
        this.setMonth = this.setMonth.bind(this);
    }

    componentDidMount() {
        let {year,month} = this.state;
        this.fetchData(year,month);
    }

    fetchData(year,month) {
        let self = this;
        let params = {
            url: `/dailyvatamount/fetch?year=${year.value}&month=${month}`,
            method: "get"
        };
        self.setState({loading:true, vatAmount:null});
        request(params)
        .then(function (response) {
            let {minYear} = response.data;
            self.setState({
                loading: false,
                vatAmount: {
                    depoInAmount: response.data.depoInAmount || 0,
                    depoInKdv: response.data.depoInKdv || 0,
                    estimatedOutAmount: response.data.estimatedOutAmount || 0,
                    estimatedOutKdv: response.data.estimatedOutKdv || 0,
                    genelInAmount: response.data.genelInAmount || 0,
                    genelInKdv: response.data.genelInKdv || 0,
                    sgkAmount: response.data.sgkAmount || 0,
                    sgkOutKdv: response.data.sgkOutKdv || 0,
                    publicAmount: response.data.publicAmount || 0,
                    publicKdv: response.data.publicKdv || 0,
                    eczaciposAmount: response.data.eczaciposAmount || 0,
                    eczaciposOutKdv: response.data.eczaciposOutKdv || 0,
                    otherInAmount: response.data.otherInAmount || 0,
                    otherInKdv: response.data.otherInKdv || 0,
                    outAmount: response.data.outAmount || 0,
                    outKdv: response.data.outKdv || 0,
                    inAmount: response.data.inAmount || 0,
                    inKdv: response.data.inKdv || 0,
                    minYear: response.data.minYear,
                },
                years: minYear ? getYearsListWithMinYear(minYear) : getYearsList()
            });
        }).catch(function (error) {
            self.setState({loading: false});
            showAxiosError(error);
        });
    }

    kdvDurumRaporu() {
        let self = this;
        let params = {
            url: `/dailyvatamount/kdvDurumRaporu?year=${this.state.year.value}&month=${this.state.month}`,
            method: "get"
        };
        self.setState({showModal: true});
        request(params)
            .then(function (response) {
                const byteCharacters = atob(response.data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'application/pdf' });

                const url = window.URL.createObjectURL(blob);
                self.setState({url: url});
            }).catch(function (error) {
            if (error.response === undefined) {
                showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
            } else {
                let enc = new TextDecoder("utf-8");
                showAxiosError({message: enc.decode(error.response.data)});
            }
            self.setState({showModal: false, title: null});
        });
    }


    setYear(year) {
        let month;
        let date = new Date();
        if (year.value === date.getFullYear()) {
            month = new Date().getMonth();
        } else {
            month = 0;
        }
        this.setState({year,month,searchQuery: undefined}, () => this.fetchData(year,month));
    }

    setMonth(month) {
        this.setState({month,searchQuery: undefined}, () => this.fetchData(this.state.year,month));
    }

    estimatedKDV(){
        let month = this.state.month;
        let year = this.state.year.value;
        let currentMonth = new Date().getMonth();
        let currentYear = new Date().getFullYear();
        let title = this.state.vatAmount ? this.state.vatAmount.outKdv : "... TL";
        let body="Giden Fatura KDV Toplam";
        if(this.state.vatAmount &&
            this.state.vatAmount.estimatedOutKdv > this.state.vatAmount.outKdv &&
            year === currentYear &&
            month === currentMonth){
            title = this.state.vatAmount ? this.state.vatAmount.estimatedOutKdv : "... TL";
            body="Tahmini Giden Fatura KDV Toplam";
        }
        return <VatCard title={title} body={body}/>
    }

    result(){
        let month = this.state.month;
        let year = this.state.year.value;
        let currentMonth = new Date().getMonth();
        let currentYear = new Date().getFullYear();
        let title=this.state.vatAmount ? this.state.vatAmount.outKdv - this.state.vatAmount.inKdv : "... TL";
        if(this.state.vatAmount &&
            this.state.vatAmount.estimatedOutKdv > this.state.vatAmount.outKdv &&
            year === currentYear &&
            month === currentMonth){
            title=this.state.vatAmount ? this.state.vatAmount.estimatedOutKdv - this.state.vatAmount.inKdv : "... TL";
        }
        return <VatCard title={title} body="KDV Fark"/>;
    }

    render() {
        if (this.state.loading) {
            return <div><ReactLoadingTop style={{width: '50px', height: '50px'}}/></div>;
        }

        return (
            <div className="row baseBackground">
                <NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
                </NavBarKS>
                <div className="col-sm-12 satirBasi">
                    <div className="col-sm-12">
                        <div className="row d-flex justify-content-between align-items-center">
                            <div className="col-sm-2">
                                <div className="card-header">
                                    <h4 className="card-title">KDV Durum Raporu</h4>
                                </div>
                            </div>
                            <div className="col-sm-2">
                                <div className="card-header">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12">
                        <YearPicker years={this.state.years}
                                    checkMonthBased={false}
                                    selectedYear={this.state.year.value}
                                    selectedMonth={this.state.month}
                                    selectedYearLabel={this.state.year.label}
                                    onSetYear={this.setYear}
                                    onSetMonth={this.setMonth}
                                    loading={this.state.loading}
                                    type="fulldate"
                                    hideReceivedDate={true}/>

                    </div>
                    <div className="card-body">
                        <table className="styled-table-new">
                            <thead>
                            <tr>
                                <th style={{width: 350}} scope="col">Satış</th>
                                <th scope="col">Tutar</th>
                                <th scope="col">KDV(10,20)</th>
                                <th scope="col">Alış</th>
                                <th scope="col">Tutar</th>
                                <th scope="col">KDV(10,20)</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td scope="row">SGK</td>
                                <td>{this.state.vatAmount.sgkAmount !== null ? this.state.vatAmount.sgkAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.sgkOutKdv !== null ? this.state.vatAmount.sgkOutKdv.toFixed(2) : "0.00"} TL</td>
                                <td scope="row">Depo Alım</td>
                                <td>{this.state.vatAmount.depoInAmount !== null ? this.state.vatAmount.depoInAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.depoInKdv !== null ? this.state.vatAmount.depoInKdv.toFixed(2) : "0.00"} TL</td>
                            </tr>
                            <tr>
                                <td scope="row">Kamu kurumuna kesilen faturalar</td>
                                <td>{this.state.vatAmount.publicAmount !== null ? this.state.vatAmount.publicAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.publicKdv !== null ? this.state.vatAmount.publicKdv.toFixed(2) : "0.00"} TL</td>
                                <td scope="row">Genel (Elektrik, Su, Doğalgaz)</td>
                                <td>{this.state.vatAmount.genelInAmount !== null ? this.state.vatAmount.genelInAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.genelInKdv !== null ? this.state.vatAmount.genelInKdv.toFixed(2) : "0.00"} TL</td>
                            </tr>
                            <tr>
                                <td scope="row">Eczacıpos</td>
                                <td>{this.state.vatAmount.eczaciposAmount !== null ? this.state.vatAmount.eczaciposAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.eczaciposOutKdv !== null ? this.state.vatAmount.eczaciposOutKdv.toFixed(2) : "0.00"} TL</td>
                                <td scope="row">Diğer Alımlar</td>
                                <td>{this.state.vatAmount.otherInAmount !== null ? this.state.vatAmount.otherInAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.otherInKdv !== null ? this.state.vatAmount.otherInKdv.toFixed(2) : "0.00"} TL</td>
                            </tr>
                            <tr>
                                <td scope="row">Diğer Satışlar</td>
                                <td>
                                    {Math.abs((this.state.vatAmount.outAmount) - (this.state.vatAmount.sgkAmount + this.state.vatAmount.publicAmount + this.state.vatAmount.eczaciposAmount)).toFixed(2)} TL
                                </td>
                                <td>
                                    {Math.abs((this.state.vatAmount.outKdv) - (this.state.vatAmount.sgkOutKdv + this.state.vatAmount.publicKdv + this.state.vatAmount.eczaciposOutKdv)).toFixed(2)} TL
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <th scope="row">Toplam</th>
                                <td>{this.state.vatAmount.outAmount !== null ? this.state.vatAmount.outAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.outKdv !== null ? this.state.vatAmount.outKdv.toFixed(2) : "0.00"} TL</td>
                                <th scope="row">Toplam</th>
                                <td>{this.state.vatAmount.inAmount !== null ? this.state.vatAmount.inAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.inKdv !== null ? this.state.vatAmount.inKdv.toFixed(2) : "0.00"} TL</td>
                            </tr>
                            <tr>
                                <th scope="row">Satış KDV</th>
                                <td>{this.state.vatAmount.outAmount !== null ? this.state.vatAmount.outAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.outKdv !== null ? this.state.vatAmount.outKdv.toFixed(2) : "0.00"} TL</td>
                                <th scope="row">Alış KDV</th>
                                <td>{this.state.vatAmount.inAmount !== null ? this.state.vatAmount.inAmount.toFixed(2) : "0.00"} TL</td>
                                <td>{this.state.vatAmount.inKdv !== null ? this.state.vatAmount.inKdv.toFixed(2) : "0.00"} TL</td>
                            </tr>
                            <br/><br/>
                            </tbody>
                        </table>
                        <table className="styled-table-new">
                            <tbody>
                            <tr>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <th scope="row">
                                    {((this.state.vatAmount.inKdv) - (this.state.vatAmount.outKdv)) > 0
                                        ? (
                                            <>
                                                <p style={{fontWeight: "normal", fontSize: 13, marginBottom: 2}}>
                                                    * (Alış KDV - Satış KDV İşlemi ile hesaplanır)
                                                </p>
                                                Devreden KDV
                                            </>
                                        )
                                        : (
                                            <>
                                                <p style={{fontWeight: "normal", fontSize: 13, marginBottom: 2}}>
                                                    * (Alış KDV - Satış KDV İşlemi ile hesaplanır)
                                                </p>
                                                Ödenecek KDV
                                            </>
                                        )}
                                </th>
                                <td>
                                    {(Math.abs(this.state.vatAmount.inAmount - this.state.vatAmount.outAmount)).toFixed(2)} TL
                                </td>
                                <td>
                                    {Math.abs(this.state.vatAmount.inKdv - this.state.vatAmount.outKdv).toFixed(2)} TL
                                </td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                                <td className="empty-cell"></td>
                            </tr>
                            </tbody>
                        </table>
                        {this.state.showModal &&
                            <MediaViewer modal={this.state.showModal}
                                         url={this.state.url}
                                         title={this.state.title}
                                         listener={() => this.setState({url: null, showModal: false})}
                            />
                        }
                    </div>
                </div>
                <StickButton
                    position="rightSide"
                    title="Pdf İndir"
                    label="Pdf İndir"
                    icon="download"
                    className="stickButton pdfVatReport"
                    onClick={() => {
                        this.kdvDurumRaporu();
                    }}
                />
            </div>
        );
    }
}

export default VatStateReport;